"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MetadataLibrary {
    constructor() {
        this.crops = [];
        this.practices = [];
        this.artificialIrrigationTypes = [];
        this.artificialIrrigationUsages = [];
    }
    setCrops(c) {
        this.crops = c;
    }
    setPractices(p) {
        this.practices = p;
    }
    setArtificialIrrigationTypes(atypes) {
        this.artificialIrrigationTypes = atypes;
    }
    setArtificialIrrigationUsages(ausages) {
        this.artificialIrrigationUsages = ausages;
    }
}
exports.default = MetadataLibrary;
